import { configList, headerTabs, footerTabs, shopList } from "@/server/api";
const state = {
  configList: {},
  headerTabs: [],
  footerTabs: [],
  shopLists: []
};
const actions = {
  async fetchConfigList({ commit }, payload) {
    const { status, data } = await configList(payload);
    if (status == 0) {
      commit("SET_CONFIGLIST", data);
    }
  },
  async fetchHeaderTabs({ commit }, payload) {
    const { status, data } = await headerTabs(payload);
    if (status == 0) {
      commit("SET_HEADERTABS", data.items);
    }
  },
  async fetchFooterTabs({ commit }, payload) {
    const { status, data } = await footerTabs(payload);
    if (status == 0) {
      commit("SET_FOOTERTABS", data.items);
    }
  },
  async fetchShopList({ commit }, payload) {
    const { status, data } = await shopList(payload);
    if (status == 0) {
      commit("SET_SHOPLISTS", data.items);
    }
  }
};
const mutations = {
  SET_CONFIGLIST: (state, payload) => {
    state.configList = payload;
  },
  SET_HEADERTABS: (state, payload) => {
    state.headerTabs = payload;
  },
  SET_FOOTERTABS: (state, payload) => {
    state.footerTabs = payload;
  },
  SET_SHOPLISTS: (state, payload) => {
    state.shopLists = payload;
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/global.js